import { Control, FieldErrors } from "react-hook-form";

import { Controller } from "react-hook-form";
import { Stack, TextField, Typography } from "@mui/material";
import { textFieldStyle } from "../../../theme";

interface TextFieldControllerProps {
  control: Control<any>;
  errors?: FieldErrors<any>;
  name: string;
  label: string;
  title: string;
  placeholder?: string;
  required?: boolean;
  width?: string;
  mask?: (value: string) => string;
  type?: React.InputHTMLAttributes<unknown>["type"];
}


export function TextFieldController({
  control,
  errors,
  name,
  label,
  title,
  placeholder,
  required = false,
  width,
  type,
  mask,
}: TextFieldControllerProps) {
  return (
    <Stack
      direction="row"
      width="100%"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography fontWeight={400} width={width ?? "400px"}>
        {title}
        {required}
      </Typography>

      <Controller
        name={name}
        control={control}
        rules={
          required
            ? { required: `${label} é obrigatória` }
            : undefined
        }
        render={({ field }) => (
        <TextField
          {...field}
          type={type}
          sx={textFieldStyle}
          fullWidth
          label={label}
          placeholder={placeholder}
          error={!!errors?.[name]}
          helperText={errors?.[name]?.message as string | undefined}
          InputLabelProps={type === "time" ? { shrink: true } : undefined}
          onChange={(e) => {
            const value = e.target.value;
            field.onChange(mask ? mask(value) : value);
          }}
        />
        )}
      />
    </Stack>
  );
}